module.exports = __webpack_public_path__ + "static/img/ikona_cw1-ON.f0748e37.png";